import * as React from 'react';
import { observer } from 'mobx-react';
import { NotFoundComponent } from '@telia-common-components/404';
import { useStores } from "@stores/RootStore";

import config from '@config';

const NotFound = () => {
  const {
    languageStore: { currentLanguage },
    translateStore: { globalTranslations },
    ssoStore: { customerType }
  } = useStores();

  return (
    <NotFoundComponent
      translations={globalTranslations}
      teliaWebUrl={config.teliaUrl}
      currentLang={currentLanguage}
      segment={customerType === 'B2B' ? 'ari' : 'era'}
    />
  );
}

export default observer(NotFound);
